var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdobeFontsLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.6663 0.000183105H-0.000305176V26.0001H26.6663V0.000183105Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6944 10.8842C14.0718 12.9709 13.5521 14.9855 12.9295 16.9544C12.5761 18.065 12.1891 19.1252 11.7011 19.7982C11.1626 20.5554 10.1529 21.2791 8.94141 21.2791C8.08314 21.2791 7.24176 20.8752 7.24176 19.9833C7.24176 19.428 7.81387 18.9064 8.26824 18.9064C8.53751 18.9064 8.67214 19.0578 8.73941 19.1756C9.16009 19.9329 9.56399 20.3703 9.7491 20.3703C9.9342 20.3703 10.0856 20.118 10.3885 19.0242L12.5911 10.8842H11.0093C10.8914 10.5308 11.0597 10.0933 11.2616 10.0092H12.8434C13.1463 9.03315 13.5016 8.05265 14.0065 7.16079C14.7637 5.79778 15.9753 4.72083 17.6411 4.72083C18.9032 4.72083 19.4248 5.32662 19.4248 6.10073C19.408 6.92521 18.6845 7.3459 18.3479 7.3459C18.0787 7.3459 17.9441 7.144 17.8599 6.85795C17.5739 5.78099 17.2036 5.46125 16.9848 5.46125C16.7662 5.46125 16.4295 5.86505 16.0594 6.70642C15.5714 7.76659 15.2497 8.89862 14.9469 10.0092H16.8652C16.9829 10.2447 16.882 10.7496 16.5959 10.8842H14.6944V10.8842Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 13.333,
    y1: 26.0001,
    x2: 13.333,
    y2: 0.000183105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#201F21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#313131"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.6667,
    height: 26,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdobeFontsLogo);
export default __webpack_public_path__ + "static/media/AdobeFontsLogo.b9765f4d10a41913216a7b6f32da3ea9.svg";
export { ForwardRef as ReactComponent };